import skMessages from '../locales/sk_SK';

const SkLang = {
  messages: {
    ...skMessages
  },
  locale: 'sk-SK'
};
export default SkLang;
